import { createFileRoute } from '@tanstack/react-router';

type Search = {
  checkOnboarding?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/dashboard')({
  validateSearch: (search: Search): Search => {
    return {
      checkOnboarding: search.checkOnboarding ? true : undefined,
    };
  },
});
